import React, { useRef, useMemo } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { History, Add, Remove, Edit } from '@material-ui/icons';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';

import { toast } from 'react-toastify';

import { UnidataTable } from '~/components';

import {
  findOperacaoBloqueioVeiculoPreFaturas,
  recordFiltering,
} from '~/store/modules/OperacaoBloqueioVeiculoPreFaturas/actions';

import HistoricoPreFaturaBloqueio from './components/HistoricoPreFaturaBloqueio';
import ProdutosVeiculo from './components/ProdutosVeiculo';
import RemoverBloqueio from './components/RemoverBloqueio';
import AdicionarBloqueio from './components/AdicionarBloqueio';
import EditarBloqueio from './components/EditarBloqueio';

function OperacaoBloqueioVeiculoPreFaturasList() {
  const dispatch = useDispatch();
  const buttons = [];
  const operacaobloqueioveiculoprefaturas = useSelector(
    (state) => state.operacaobloqueioveiculoprefaturas
  );

  const historicobloqueioveiculoRef = useRef();
  const produtoveiculoRef = useRef();
  const AdicionarBloqueioRef = useRef();
  const EditarBloqueioRef = useRef();
  const RemoverBloqueioRef = useRef();
  const [itemSelecionado, setItemSelecionado] = React.useState({});

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(operacaobloqueioveiculoprefaturas.params));
  }, [operacaobloqueioveiculoprefaturas.params]);

  const adicionarBloqueio = React.useCallback(
    (value) => {
      if (value.veic_bloqueio_faturamento == 'N') {
        AdicionarBloqueioRef.current.handleToggleModal(value);
      } else {
        toast.error('O registro já se encontra bloqueado.');
      }
    },
    [AdicionarBloqueioRef]
  );

  const editarBloqueio = React.useCallback(
    (value) => {
      if (value.veic_bloqueio_faturamento == 'S') {
        EditarBloqueioRef.current.handleToggleModal(value);
      } else {
        toast.error(
          'O registro não se encontra bloqueado, portanto não é possível editar.'
        );
      }
    },
    [EditarBloqueioRef]
  );

  const removerBloqueio = React.useCallback(
    (value) => {
      if (value.veic_bloqueio_faturamento == 'S') {
        RemoverBloqueioRef.current.handleToggleModal(value);
      } else {
        toast.error('O registro não se encontra bloqueado.');
      }
    },
    [RemoverBloqueioRef]
  );

  const header = useMemo(
    () => [
      {
        id: 'veic_placa_aux',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_codigo',
        label: 'Cód Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_codigo',
        label: 'Cód Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'veic_status',
        label: 'Status',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'desc_veic_bloqueio_faturamento',
        label: 'Bloqueio Faturamento',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'veic_codigo_pleito',
        label: 'Pleito',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Desc Órgão',
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Desc Unidade',
        align: 'left',
      },

      {
        id: 'vemm_codigo',
        label: 'Cód Modelo',
        align: 'left',
      },
      {
        id: 'vemm_nome',
        label: 'Marca/Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_modelo',
        label: 'Ano Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_fabricacao',
        label: 'Ano Fabricação',
        align: 'left',
      },
      {
        id: 'veic_renavam',
        label: 'Renavam',
        align: 'left',
      },
      {
        id: 'veic_tag1',
        label: 'Transp 01',
        align: 'right',
      },
      {
        id: 'veic_tag2',
        label: 'Transp 02',
        align: 'right',
      },
      {
        id: 'veic_idxbee',
        label: 'DVEC',
        align: 'right',
      },
    ],
    []
  );

  const headerbuttons = useMemo(
    () => [
      buttons.push({
        title: 'Histórico de bloqueio',
        action: (value) =>
          historicobloqueioveiculoRef.current.handleToggleModal(value),
        icon: <History />,
      }),

      buttons.push({
        title: 'Produtos do Veículo',
        action: (value) => produtoveiculoRef.current.handleToggleModal(value),
        icon: <LocalGasStationIcon />,
      }),

      itemSelecionado.veic_bloqueio_faturamento === 'N' &&
        buttons.push({
          title: 'Adicionar bloqueio',
          action: (value) => adicionarBloqueio(value),
          icon: <Add />,
        }),

      itemSelecionado.veic_bloqueio_faturamento === 'S' &&
        buttons.push({
          title: 'Editar bloqueio',
          action: (value) => editarBloqueio(value),
          icon: <Edit />,
        }),

      itemSelecionado.veic_bloqueio_faturamento === 'S' &&
        buttons.push({
          title: 'Remover bloqueio',
          action: (value) => removerBloqueio(value),
          icon: <Remove />,
        }),
    ],
    [operacaobloqueioveiculoprefaturas, itemSelecionado]
  );

  const registroSelecionado = React.useCallback(
    (values) => {
      setItemSelecionado(values);
    },
    [operacaobloqueioveiculoprefaturas]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="veic_placa ASC"
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        find={findOperacaoBloqueioVeiculoPreFaturas}
        redux={operacaobloqueioveiculoprefaturas}
        read={recordFiltering}
        actions={buttons}
        detach="veic_placa"
        onRow={(values) => registroSelecionado(values)}
        view="VW_VEICULO"
        reportTitle="Bloqueio Veículo Pré-Fatura"
      />

      <HistoricoPreFaturaBloqueio
        ref={historicobloqueioveiculoRef}
        update={() => handleUpdate()}
        name="HistoricoPreFaturaBloqueio"
      />

      <ProdutosVeiculo
        ref={produtoveiculoRef}
        update={() => handleUpdate()}
        name="ProdutosVeiculo"
      />

      <AdicionarBloqueio
        ref={AdicionarBloqueioRef}
        update={() => handleUpdate()}
        name="AdicionarBloqueio"
      />

      <EditarBloqueio
        ref={EditarBloqueioRef}
        update={() => handleUpdate()}
        name="EditarBloqueio"
      />

      <RemoverBloqueio
        ref={RemoverBloqueioRef}
        update={() => handleUpdate()}
        name="RemoverBloqueio"
      />
    </>
  );
}

export default OperacaoBloqueioVeiculoPreFaturasList;
